export { default } from "./BaseImage";
